import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration - Replace with your Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyBs7dGbGvfFv5xnGj662PT5qPVtgvBaB4s",
    authDomain: "ezk-wettbewerb.firebaseapp.com",
    projectId: "ezk-wettbewerb",
    storageBucket: "ezk-wettbewerb.firebasestorage.app",
    messagingSenderId: "651746724842",
    appId: "1:651746724842:web:70bced5786910bca518093",
    measurementId: "G-71PVWK397Z"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only in browser environment (exported for optional use)
export let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics initialization failed:', error);
  }
}

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);

export default app;